import {useDefaultQuery} from "../../../../common/apis/ReactQuery";
import userApiClient from "../../../../common/apis/user/UserApiClient";

export function useUserByLoginQuery(login: string) {
    return useDefaultQuery({
        queryKey: ["users", login],
        queryFn: () => userApiClient.getUserByLogin(login),
    });
}